import { useMemo } from 'react';

import { LedgerApi } from 'api/ledger';

function useLedgerApi() {
    return useMemo(() => new LedgerApi(), []);
}

export { useLedgerApi };
